import { Component, OnInit, inject } from '@angular/core';
import {MediaService} from '@exl-ng/mulo-core';
import {ConfigurationHandlerService} from '../../core/configuration-handler.service';
import {
    PortalSearch,
    SearchEntities,
    SearchScopesByEntity
} from '../../shared/configurations/portal-search.constant';
import {Discovery} from '../../shared/configurations/discovery.constant';
import {Router} from '@angular/router';
import {UrlUtils} from '../../shared/utils/url.utils';
import {State} from '../../shared/configurations/state.constant';
import { PortalService } from '../portal.service';
import { EntitySearchService } from '../../discovery/entity-search.service';
import { TranslateModule } from '@ngx-translate/core';

import { SearchbarComponent, SearchbarOptionsComponent } from '@exl-ng/mulo-common';

@Component({
    selector: 'esp-portal-title',
    templateUrl: './portal-title.component.html',
    styleUrls: ['./portal-title.component.scss'],
    imports: [SearchbarComponent, SearchbarOptionsComponent, TranslateModule]
})
export class PortalTitleComponent implements OnInit{
    media = inject(MediaService);
    private configurationHandlerService = inject(ConfigurationHandlerService);
    private router = inject(Router);
    private portalService = inject(PortalService);
    private entitySearchService = inject(EntitySearchService);


    institutionCode = UrlUtils.getParam('institution');

    searchEntities = [];

    activeEntity = SearchEntities.OUTPUTS_ENTITY;
    selectedEntity = SearchEntities.OUTPUTS_ENTITY;
    searchScopesByEntity = [];
    activeScope: string;
    selectedScope: string;

    ngOnInit(){
        this.searchEntities = this.entitySearchService.getSearchEntities();
        this.activeEntity = this.searchEntities[0].value;
        this.handleEntityChange(this.activeEntity);
        this.setSearchScopesByEntity(this.activeEntity);
    }

    handleEntityChange(entity) {
        this.selectedEntity = entity;
        this.setSearchScopesByEntity(entity);
    }

    handleScopeChange(scope) {
        this.selectedScope = scope;
    }

    setSearchScopesByEntity(entity: string) {
        this.searchScopesByEntity = this.searchEntities.filter(s => s.value === entity)[0].scopes;
        if (this.searchScopesByEntity.length > 0){
            this.setCurrentScope(this.searchScopesByEntity[0].value);
        }
    }

    setCurrentScope(scope) {
        this.activeScope = scope;
        this.selectedScope = scope;
    }

    goToSearch(e){
        const query = e.query;
        if (query){
            if (this.selectedEntity === SearchEntities.OUTPUTS_ENTITY){
                this.goToOutputsSearch(query, this.selectedScope);
            } else if (this.selectedEntity === SearchEntities.RESEARCHERS_ENTITY){
                this.goToResearchersSearch(query, this.selectedScope);
            } else if (this.selectedEntity === SearchEntities.PROJECTS_ENTITY){
                this.goToProjectsSearch(query, this.selectedScope);
            }
        }
    }

    goToResearchersSearch(query: string, scope: string) {
        this.router.navigate([State.RESEARCHERS_SEARCH], {
            queryParams: {
                query,
                page: 1,
                scope,
                institution: this.institutionCode,
            },
        });
    }

    goToOutputsSearch(query: string, scope: string) {
        this.router.navigate([State.OUTPUTS_SEARCH], {
            queryParams: {
                query: Discovery.SIMPLE_SEARCH_QUERY_PREFIX + query,
                page: 1,
                scope,
                institution: this.institutionCode,
            },
        });
    }

    goToProjectsSearch(query: string, scope: string) {
        this.router.navigate([State.PROJECTS_SEARCH], {
            queryParams: {
                query,
                page: 1,
                scope,
                institution: this.institutionCode,
            },
        });
    }

}
